class CommonSettings {
  constructor() {
    this.ANALYZER_ID = 782;
    this.current_server_url = "";

    this.FIXED_BASE_URL = "https://api.sdm.3rd-eye.tv/sdm/"; // New r&D, Fixed URL is For To get the video URL

    this.SERVER_BASE_URL = "https://apidrs4051.3rd-eye.tv/sdm/"; //live drs api 4051  , sdm_drslive_client
    this.LOCAL_BASE_URL = "https://192.168.1.100:4051/sdm/";  // drs live
  }
}

export default new CommonSettings();
